<script setup lang="ts">
defineProps<{
  title: string;
  lead: string;
  updated: string;
}>();

const year = new Date().getFullYear();
</script>

<template>
  <VMain class="bg-secondary">
    <VAppBar elevation="0" class="legal-nav border-b" color="secondary">
      <VContainer class="landing-container d-flex align-center ga-4">
        <a href="/" class="d-flex align-center">
          <img
            src="/branding/klupz-logo.svg"
            alt="Klupz"
            class="legal-nav__logo"
          />
        </a>
        <VSpacer />
        <VBtn color="primary" variant="text" href="/">Terug naar home</VBtn>
      </VContainer>
    </VAppBar>

    <VContainer class="landing-container legal">
      <p class="landing-eyebrow">Juridisch</p>
      <h1 class="landing-h1">{{ title }}</h1>
      <p class="legal__lead">{{ lead }}</p>
      <p class="legal__meta">Versie 1.0 • {{ updated }}</p>

      <article class="legal__body">
        <slot />
      </article>

      <nav class="legal__other" aria-label="Andere documenten">
        <a href="/algemene-voorwaarden">Algemene voorwaarden</a>
        <a href="/privacybeleid">Privacybeleid</a>
      </nav>
    </VContainer>

    <footer class="legal-footer">
      <VContainer class="landing-container">
        <span>© {{ year }} Klupz</span>
        <a href="mailto:info@bytechnology.nl">info@bytechnology.nl</a>
      </VContainer>
    </footer>
  </VMain>
</template>

<style scoped lang="scss">
.legal-nav__logo {
  height: 28px;
  width: auto;
}

.legal {
  max-width: 820px;
  padding-top: 56px;
  padding-bottom: 56px;
}

.legal__lead {
  font-size: 17px;
  line-height: 1.6;
  color: rgb(var(--v-theme-emphasis));
  margin: 16px 0 8px;
}

.legal__meta {
  font-size: 13px;
  color: rgb(var(--v-theme-emphasis));
  margin: 0 0 32px;
}

.legal__body {
  background: white;
  border: 1px solid rgb(var(--v-theme-border));
  border-radius: 16px;
  padding: 32px;

  :deep(h2) {
    font-size: 18px;
    font-weight: 800;
    color: rgb(var(--v-theme-accent));
    margin: 28px 0 10px;

    &:first-child {
      margin-top: 0;
    }
  }

  :deep(p),
  :deep(li) {
    font-size: 15px;
    line-height: 1.7;
    margin: 0 0 10px;
  }

  :deep(ul) {
    padding-left: 20px;
    margin: 0 0 10px;
  }

  :deep(a) {
    color: rgb(var(--v-theme-primary));
  }

  :deep(table) {
    width: 100%;
    border-collapse: collapse;
    margin: 12px 0 18px;
    font-size: 14px;
    display: block;
    overflow-x: auto;
  }

  :deep(th) {
    text-align: left;
    background: rgb(var(--v-theme-secondary));
    color: rgb(var(--v-theme-on-secondary));
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 10px 14px;
  }

  :deep(td) {
    padding: 10px 14px;
    border-top: 1px solid rgb(var(--v-theme-border));
    vertical-align: top;
  }

  :deep(td:first-child) {
    font-weight: 700;
  }
}

.legal__other {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 28px;
  font-size: 14px;
  font-weight: 600;
}

.legal-footer {
  padding: 24px 0 32px;
  font-size: 12.5px;
  color: rgb(var(--v-theme-emphasis));
  border-top: 1px solid rgb(var(--v-theme-border));

  .v-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
  }
}

@media (max-width: 600px) {
  .legal {
    padding-top: 32px;
  }

  .legal__body {
    padding: 20px;
  }
}
</style>
